<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-cog-outline</v-icon>{{$t('profile.sectionparameter.sectionparameters')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <SectionParameterForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>


<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import SectionParameterForm from '../../components/sectionparameter/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'SectionParameter';

const { mapFields } = createHelpers({
  getterType: 'sectionparameter/getField',
  mutationType: 'sectionparameter/updateField'
});

export default {
  name: 'SectionParameterCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    SectionParameterForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('sectionparameter', ['create', 'reset'])
  }
};
</script>
